const read_status_key = (value = '') => {
    return `${value || ''}`.trim().toLowerCase().replace(/[\s-]+/g, '_');
};

export const read_sass_edit_permissions = (boardStatus = '', canManageAssignments = false) => {
    const status = read_status_key(boardStatus);
    const isInProgress = status === 'in_progress';

    return {
        canEditAssignee: isInProgress || (status === 'set' && canManageAssignments),
        canEditAccount: isInProgress,
        canEditComments: isInProgress,
        canSelectOutcome: isInProgress,
        viewOnly: !isInProgress
    };
};

export const read_sass_slider_primary_action = (boardStatus = '', outcome = '') => {
    const permissions = read_sass_edit_permissions(boardStatus);

    if (permissions.canEditAccount && !read_status_key(outcome).length) {
        return 'save_account';
    }

    if (permissions.canSelectOutcome) {
        return 'submit_outcome';
    }

    return 'close';
};
